/** `uiKit` translations, for every locale: the shared ErrorState and SearchSelect in components/ui. */
export const uiKit = {
  mn: {
    uiKit: {
      retry: 'Дахин оролдох',
      status: 'код {{status}}',
      noResponse: 'Сервер хариу өгсөнгүй. Холболтоо шалгаад дахин оролдоно уу.',
      forbidden: 'Танд үүнийг харах эрх алга.',
      notFound: 'Олдсонгүй: устгагдсан эсвэл зөөгдсөн байж магадгүй.',
      serverFailed: 'Серверт алдаа гарлаа. Дахин оролдоно уу.',
      noMatch: 'Тохирох зүйл олдсонгүй',
    },
  },
  en: {
    uiKit: {
      retry: 'Try again',
      status: 'code {{status}}',
      noResponse: 'The server did not answer. Check your connection and try again.',
      forbidden: 'You do not have access to this.',
      notFound: 'Not found: it may have been deleted or moved.',
      serverFailed: 'The server hit an error. Try again.',
      noMatch: 'Nothing matches',
    },
  },
  ru: {
    uiKit: {
      retry: 'Повторить',
      status: 'код {{status}}',
      noResponse: 'Сервер не ответил. Проверьте подключение и повторите попытку.',
      forbidden: 'У вас нет доступа к этому.',
      notFound: 'Не найдено: возможно, удалено или перемещено.',
      serverFailed: 'Ошибка на сервере. Повторите попытку.',
      noMatch: 'Ничего не найдено',
    },
  },
}
